import { mediaItems } from '@/mocks/homeData';

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1200px] mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-4xl font-display text-foreground-950">
              视频爆料
            </h2>
            <p className="mt-2 text-sm md:text-base text-foreground-500">
              深度视频内容，多角度还原事件真相
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
            {mediaItems.map((item) => (
              <div
                key={item.id}
                className="group bg-background-50 border border-background-200/70 rounded-lg overflow-hidden hover:border-primary-300 transition-colors duration-300 cursor-pointer"
              >
                <div className="relative aspect-video overflow-hidden bg-background-200">
                  <img
                    src={item.image}
                    alt={`吃瓜爆料视频 - ${item.title}`}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 flex items-center justify-center">
                    <div className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-background-50/90 flex items-center justify-center group-hover:bg-primary-500 transition-colors duration-300">
                      <i className="ri-play-fill text-xl md:text-2xl text-primary-500 group-hover:text-background-50 transition-colors duration-300 w-5 h-5 flex items-center justify-center"></i>
                    </div>
                  </div>
                  <span className="absolute bottom-3 right-3 px-2 py-1 bg-black/70 text-background-50 text-xs rounded whitespace-nowrap">
                    {item.duration}
                  </span>
                  <span className="absolute top-3 left-3 px-2.5 py-1 bg-accent-500 text-background-50 text-xs font-medium rounded-full whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <div className="p-4">
                  <h3 className="text-sm md:text-base font-display text-foreground-900 group-hover:text-primary-500 transition-colors duration-200 line-clamp-2">
                    {item.title}
                  </h3>
                  <div className="flex items-center gap-1 mt-2 text-xs text-foreground-400">
                    <i className="ri-eye-line w-3 h-3 flex items-center justify-center"></i>
                    <span>{item.views} 次观看</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}